document.addEventListener('DOMContentLoaded', function () {

  // Quantity selectors (product page + cart)
  document.querySelectorAll('[data-quantity-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-quantity-input]');
      var val = parseInt(input.value, 10) || 1;
      input.value = Math.max(parseInt(input.min, 10) || 0, val - 1);
      input.dispatchEvent(new Event('change'));
    });
  });
  document.querySelectorAll('[data-quantity-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-quantity-input]');
      var val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  // Product gallery thumbnails
  var mainImage = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImage) mainImage.src = thumb.getAttribute('data-full');
    });
  });

  // Ajax add-to-cart for all buy forms (product page + featured product box)
  document.querySelectorAll('form.js-ajax-cart').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          if (window.ncCart && window.ncCart.refresh) { window.ncCart.refresh(true); }
          else { window.location.href = '/cart'; }
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  });

  function showCartNotification(message) {
    var el = document.getElementById('cart-notification');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    setTimeout(function () { el.classList.remove('is-visible'); }, 2800);
  }
});


/* Cart-Drawer */
(function () {
  var SECTION = 'cart-drawer';
  var drawer, busy = false, timers = {};

  function el() { return drawer || (drawer = document.getElementById('CartDrawer')); }
  function setCount(n) { document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = n; }); }

  function open() {
    var d = el(); if (!d) return false;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var p = d.querySelector('.cart-drawer__panel'); if (p) p.focus();
    return true;
  }
  function close() {
    var d = el(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function render(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawerInner');
    var cur = document.getElementById('CartDrawerInner');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    var c = cur && cur.querySelector('[data-drawer-count]');
    if (c) setCount(c.getAttribute('data-drawer-count'));
  }
  function refresh(openAfter) {
    return fetch(window.location.pathname + '?sections=' + SECTION)
      .then(function (r) { return r.json(); })
      .then(function (data) { render(data[SECTION]); if (openAfter) open(); })
      .catch(function () { if (openAfter) window.location.href = '/cart'; });
  }
  function change(key, qty) {
    var line = document.querySelector('[data-line-key="' + key + '"]');
    if (line) line.classList.add('is-loading');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: SECTION, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections) render(data.sections[SECTION]); else refresh(false);
        if (typeof data.item_count === 'number') setCount(data.item_count);
      })
      .catch(function () { refresh(false); });
  }
  function queue(key, qty) {
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () { change(key, Math.max(0, qty)); }, 350);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-cart-open]');
    if (opener && el()) { e.preventDefault(); open(); return; }
    if (t.closest('[data-cart-close]')) {
      var a = t.closest('a[href]');
      close();
      if (!a) e.preventDefault();
      return;
    }
    var line = t.closest('[data-line-key]');
    if (!line) return;
    var input = line.querySelector('[data-line-qty]');
    var key = line.getAttribute('data-line-key');
    if (t.closest('[data-line-minus]')) { input.value = Math.max(0, (parseInt(input.value, 10) || 1) - 1); queue(key, parseInt(input.value, 10)); }
    else if (t.closest('[data-line-plus]')) { input.value = (parseInt(input.value, 10) || 0) + 1; queue(key, parseInt(input.value, 10)); }
    else if (t.closest('[data-line-remove]')) { line.classList.add('is-loading'); change(key, 0); }
  });
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-line-qty]'); if (!input) return;
    var line = input.closest('[data-line-key]');
    var v = parseInt(input.value, 10); if (isNaN(v)) return;
    queue(line.getAttribute('data-line-key'), v);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  window.ncCart = { open: open, close: close, refresh: refresh };
})();

/* Warenkorb-Seite: Menge automatisch speichern */
(function () {
  var form = document.querySelector('form.cart-form');
  if (!form) return;
  var t;
  form.addEventListener('change', function (e) {
    if (!e.target.matches('[data-quantity-input]')) return;
    clearTimeout(t); t = setTimeout(function () { form.submit(); }, 400);
  });
})();
